import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "events-table-filters" }
const _hoisted_2 = { class: "events-table-filters__item events-table-filters__checkbox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectMultiComponentCheckbox = _resolveComponent("SelectMultiComponentCheckbox")!
  const _component_InputBlock = _resolveComponent("InputBlock")!
  const _component_SelectMultiComponent = _resolveComponent("SelectMultiComponent")!
  const _component_ComponentInput = _resolveComponent("ComponentInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.hideSubjectFilter)
      ? (_openBlock(), _createBlock(_component_InputBlock, {
          key: 0,
          title: "Субъект РФ",
          class: "events-table-filters__item"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SelectMultiComponentCheckbox, {
              modelValue: _ctx.filter.subjectRfIds,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter.subjectRfIds) = $event)),
              options: _ctx.regionsList,
              placeholder: "Все",
              valueProp: "id",
              trackBy: "name",
              labelOptions: "name",
              class: "events-table-filters__input"
            }, null, 8, ["modelValue", "options"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.hideCountryFilter)
      ? (_openBlock(), _createBlock(_component_InputBlock, {
          key: 1,
          title: "Страна-партнер",
          class: "events-table-filters__item"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SelectMultiComponent, {
              modelValue: _ctx.filter.countryId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter.countryId) = $event)),
              options: _ctx.partnerCountryList,
              placeholder: "Все",
              classSelect: "multiselect--rectangular",
              valueProp: "id",
              trackBy: "name",
              labelOptions: "name",
              class: "events-table-filters__input"
            }, null, 8, ["modelValue", "options"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_InputBlock, {
      title: "Вид мероприятия",
      class: "events-table-filters__item"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SelectMultiComponent, {
          modelValue: _ctx.filter.typeEventId,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filter.typeEventId) = $event)),
          options: _ctx.eventTypes,
          placeholder: "Все",
          classSelect: "multiselect--rectangular",
          valueProp: "id",
          trackBy: "name",
          labelOptions: "name",
          class: "events-table-filters__input"
        }, null, 8, ["modelValue", "options"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ComponentInput, {
        modelValue: _ctx.filter.significantFlag,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filter.significantFlag) = $event)),
        type: "checkbox",
        mod: "checkbox-green",
        label: "Значимое мероприятие",
        id: "significant-flag-filter"
      }, null, 8, ["modelValue"])
    ])
  ]))
}